/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-22 16:16:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 16:18:03
 * @FilePath: \mrc-ess-fronted\src\mixin\btnPermission.js
 */
export default {
  data() {
    return {
      BtnPermission: [], //按钮权限数组
    };
  },
  watch: {
    BtnPermission() {},
  },
  filters: {
    Permissions(name, callback) {
      return callback(name);
    },
  },
  methods: {
    async getBtnPermissionList() {
      if (!this.$store.state.FunctionUuid) return;
      return new Promise(async (resolve, reject) => {
        const res = await this.$Request({
          method: "POST",
          table: "mrbase_sys_function_buttons",
          url: "/functions/onload-button/",
          data: {
            function_uuid: this.$store.state.FunctionUuid,
          },
          type: "lang",
        }).then((res) => {
          this.BtnPermission = res.data;
          resolve(res.data);
        });
      });
    },
    hasBtn(name) {
      if (process.env.VUE_APP_MODE == "lsj") return true; //上帝模式。权限开放
      let btnName =
        Object.prototype.toString.call("name").indexOf("String") > -1
          ? [name]
          : name;
      const btnPermission = this.BtnPermission || [];
      return btnName.some((item) => btnPermission.includes(item));
    },
  },
};
